export enum Modes {
  Tracked,
  Practice,
  Screener,
  Review,
  Lesson,
  LessonTracked,
  SkillCheck,
  ReviewSkillsCheck
}